import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  main: {
    background: "rgba(67, 71, 91, 0.25)",
    borderRadius: "5px",
    padding: "7.5px",
    "&:last-child": {
      paddingBottom: "5px"
    }
  },
  cardsText: {
    color: "rgb(255,255,255)",
    fontFamily: "Roboto",
    fontSize: "22px",
    marginTop: "4px"
  },
  cardTitle: {
    color: "rgba(255, 255, 255, 0.5)",
    fontSize: "12px",
    letterSpacing: "2px",
    textTransform: "uppercase"
  }
});

const GraphDataCardMobile = ({ data, dataType, color }) => {
  const classes = useStyles();
  const chartType = dataType.split(" ");

  return (
    <CardContent
      classes={{ root: classes.main }}
      style={{ borderLeft: `5px ${color} solid` }}
    >
      <Typography variant="h2" className={classes.cardTitle}>
        {chartType[chartType.length - 1]}
        {/* {dataType.title} */}
      </Typography>
      <Typography
        variant="h2"
        id={dataType.split(" ").join("-")}
        className={classes.cardsText}
      >
        {/* {data.toFixed(dataType.toFixed)} {dataType.measurement} */}
        {data}
      </Typography>
    </CardContent>
  );
};

export default GraphDataCardMobile;
